
import SettingsBar from '@/components/common/SettingsBar.vue';
import SettingsPageLayout from '@/pages/settings/SettingsPageLayout.vue';
import { aclModule } from '@/store/acl';
import { dataModule } from '@/store/data';
import NButton from '@/uikit/buttons/NButton.vue';
import NForm from '@/uikit/forms/NForm.vue';
import NInput from '@/uikit/input/NInput.vue';
import { ITableCellChangePayload } from '@/uikit/table/NTableCell.vue';
import NTabs from '@/uikit/tabs/NTabs.vue';
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import cameraGroupColumns from './camera-groups-columns';
import NFormBlocks from '@/uikit/forms/NFormBlocks.vue';
import { multisidebarModule } from '@/store/multisidebar';
import { GlobalEvent } from '@/store/global-event/types';
import { globalEventModule, GlobalEventName } from '@/store/global-event';
import { merge } from 'lodash';
import { MultisidebarItemTypes } from '@/store/multisidebar/types';
import NTable from '@/uikit/table/NTable.vue';
import { actionHandler } from '@/store/data/ActionHandler';
import { ItemsActionNames } from '@/definitions/app/item.actions.name';

const AclModelName = 'cameragroup';
const AclItemPropertyName = 'camera_group_permissions';
const ActionPathNames = {
  Name: 'name',
  Active: 'active'
};
const SidebarType = MultisidebarItemTypes.CameraGroups;

@Options({
  name: 'CameraGroupsPage',
  components: {
    NTable,
    NFormBlocks,
    SettingsPageLayout,
    SettingsBar,
    NTabs,
    NForm,
    NButton,
    NInput
  }
})
export default class CameraGroupsPage extends Vue {
  searchQuery = '';
  cameraGroupColumns = cameraGroupColumns;

  get module() {
    dataModule.cameraGroupsModule.aclModelName = AclModelName;
    return dataModule.cameraGroupsModule;
  }

  get selectedItemsIds() {
    return this.sidebarModule.getItemsByType(SidebarType).map((v) => v.model.item.id);
  }

  get modelAcl() {
    return aclModule.getModelAcl(this.module);
  }

  get items() {
    const re = new RegExp(this.searchQuery, 'i');
    return this.module.items.filter((item) => re.test(item.name));
  }

  get maxAcl() {
    return { view: this.modelAcl.view, update: this.modelAcl.update, delete: this.modelAcl.delete };
  }

  get disabledItemIds() {
    return this.itemsAcl.filter(({ acl }) => !acl.update).map(({ itemId }) => itemId);
  }

  get itemsAcl() {
    return this.module.items.map((item) => ({
      itemId: item.id,
      acl: aclModule.getItemAclByUserProperty(item.id, AclItemPropertyName, this.maxAcl)
    }));
  }

  get lastPageEvent() {
    return globalEventModule.current?.type === SidebarType ? globalEventModule.current : null;
  }

  get sidebarModule() {
    return multisidebarModule;
  }

  @Watch('lastPageEvent')
  handleGlobalEvent(event: GlobalEvent) {
    if (!event) return;
    switch (event.name) {
      case GlobalEventName.Create:
      case GlobalEventName.Delete:
        this.module.getStatistics();
        break;
      case GlobalEventName.Update:
        merge(
          this.module.items.find((v) => v.id === event.payload.id),
          event.payload
        );
        break;
    }
  }

  mounted() {
    this.module.get();
  }

  handleSelectChanges(changesSelectionIds: number[]) {
    this.module.items
      .filter((v) => changesSelectionIds.includes(v.id))
      .forEach((v) => {
        actionHandler.run(ItemsActionNames.ToggleSelectItem, { type: SidebarType, rawItem: v });
      });
  }

  handleCreate() {
    this.sidebarModule.addNewItemByType(SidebarType);
  }

  handleTableAction(payload: ITableCellChangePayload) {
    if (payload.type === 'change') {
      switch (payload.path) {
        case ActionPathNames.Active:
          actionHandler.run(ItemsActionNames.UpdateActiveField, { type: SidebarType, rawItem: payload.row });
          break;
        case ActionPathNames.Name:
          actionHandler.run(ItemsActionNames.ShowItem, { type: SidebarType, rawItem: payload.row });
      }
    }
  }

  handleTableSort(columnName: string) {
    const ordering = this.module.filter.current.ordering === columnName ? `-${columnName}` : columnName;
    this.module.filter.current.ordering = ordering;
    this.module.get();
  }
}
